import React from 'react'
import { Button, Tooltip } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

export interface AddButtonProps {
  onClick: () => void
  /** Texto do botão e tooltip (ex.: "Adicionar", "Criar Usuário"). */
  title: string
  disabled?: boolean
}

/**
 * Botão da barra de comandos: ícone + texto, visível em qualquer tema.
 */
const AddButton: React.FC<AddButtonProps & { showText?: boolean }> = ({
  onClick,
  title,
  disabled = false,
  showText = false,
}) => (
  <Tooltip title={title}>
    <Button
      variant="contained"
      size="medium"
      startIcon={<AddIcon />}
      onClick={onClick}
      disabled={disabled}
      aria-label={title}
      sx={{ minWidth: showText ? 'auto' : 40, px: showText ? 2 : 1 }}
    >
      {showText && title}
    </Button>
  </Tooltip>
)

export default AddButton
